import { bool } from 'prop-types';
import cx from 'classnames';
import { Button } from '@fff-web/fff-ui-shared';
import env from '../../../utils/env';
import * as classNames from './ClosedNonParticipant.module.css';

const ClosedNonParticipant = (props) => {
  const { isMobile, isExpired } = props;

  const handleRedirect = () => (window.location.href = `${env.envURL}/customize`);

  return (
    <div
      className={cx(classNames.container, {
        [classNames.mobile]: isMobile,
      })}
    >
      <i className={classNames.icon} />
      <h3 className={classNames.header}>Customization is currently closed.</h3>
      <div className={classNames.info}>
        {!isExpired && (
          <p>
            You will get an email when it&apos;s time to customize your next box! Any customizations
            you make will display here.{' '}
          </p>
        )}
        <Button onClick={handleRedirect}>LEARN MORE</Button>
      </div>
    </div>
  );
};

ClosedNonParticipant.propTypes = {
  isMobile: bool.isRequired,
  isExpired: bool.isRequired,
};

export default ClosedNonParticipant;
